import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { BloodGroupDTO } from './dto/blood-group.dto';


export class BGroupResponseModel extends GlobalResponseObject {
    data?: any;
    response: BloodGroupDTO[];
}
export class AllBGroupResponseModel extends GlobalResponseObject{
    data?: any[];
}





